import script from "./FilterSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./FilterSidebar.vue?vue&type=style&index=0&id=12102a68&lang=scss"

const __exports__ = script;

export default __exports__